import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ServerErrorMessage } from '../../../../shared/utils/error';
import UsuariosScreen from './screen';
import { CostosAñoAdapter, CostoAño } from '../../../../infraestructure/persistence/rest/CostosAñoAdapter';
import { useNotifications } from '../../../../shared/hooks/Notifications';

const CostosContainer = () => {

	const api = new CostosAñoAdapter();
	const {resultError, exceptionError, launchNotification}  = useNotifications();
	let [ costos, setCostos ] = useState<any>([]);
	let result: any;

	// useEffect(() => {
	// 	//parseInt(moment().format('YYYY'))
	// 	getCostosAño(2020);
	// }, []);

	useEffect(() => {}, [ costos ]);

	const getCostosAño = async (año:number) => {
		try {
			result = await api.ListarCostosAño(año);
			if(result.data && result.data!=="")
			{
				setCostos([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	const createCosto = async (costo: any) => {
		try {
			const result:any = await api.CrearCosto(costo);
			if(result.data && result.data!=="")
			{
				setCostos([ ...costos,...result.data ] || []);
				launchNotification({type:"success",title:"Creación",message:"Se ha creado una nuevo costo."})
			}else{
				resultError()
			}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
		}
	};

	const updateCostoAño = async (costo: any) => {
		try {
			result = await api.ModificarCosto(costo);
			if(result.data && result.data!=="")
			{
				let pos = costos.findIndex((ca: CostoAño) => ca.dni === costo.dni && ca.año === costo.año);
				let newData = [ ...costos ];
				newData[pos] = result.data[0];
				setCostos([ ...newData ] || []);
				launchNotification({type:"success",title:"Modificación",message:"Se ha modificado un costo."})
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	 };

	 const deleteAction = async (data: any) => {
		let costos = data.map((ca:CostoAño) => {return {Año: ca.año, Dni: ca.dni}});
		costos.length > 1 ? deleteCostos(costos) : deleteCosto(costos[0].Año,costos[0].Dni);
	}

	 const deleteCosto = async (año: number, dni: string,) => {
		try {
			result = await api.EliminarCosto(año, dni);
			if(result.data && result.data!=="")
			{
				let pos = costos.findIndex((ac: CostoAño) => ac.dni === dni && ac.año  === año);
				let newData = [ ...costos ];
				newData.splice(pos, 1);
				setCostos([ ...newData ] || []);
				launchNotification({type:"success",title:"Eliminación",message:"Se ha eliminado un costo."})
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	const deleteCostos = async (data:any) => {
		try {
			result = await api.EliminarCostos(data);
			if(result.data && result.data!=="")
			{
				launchNotification({type:"success",title:"Eliminación",message:"Se ha eliminado un costo."})
				return result.data;
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
			return result.data
		}
	};

	return (
		<>
		<UsuariosScreen
			data={costos}
			handleFilter={getCostosAño}
			handleCreate={createCosto}
			handleUpdate={updateCostoAño}
			handleRemove={deleteAction}
		/>
		</>
	);
};

export default CostosContainer;
